module.exports = __webpack_public_path__ + "static/img/coupon-off.678a553a.png";